import { detect } from "detect-browser";

export default {
    loadTrustpilotWidget(ref) {
        if (!ref) {
            return
        }
        if (!window.Trustpilot) {
            return
        }

        try {
            window.Trustpilot.loadFromElement(ref)
        } catch (error) {
            console.log(error)
        }
    },
    isSafari(){
        const browser = detect()
        return browser.name.toLowerCase() === 'safari' || browser.name.toLowerCase() === 'ios'
    },
    isSafariMac(){
        const browser = detect()
        if(browser.name.toLowerCase() !== 'safari'){
            return false
        }
        return browser.os.toLowerCase().includes('mac')
    },
    isMaxWidth(device){
        const breakpoints  = {
            mobile: 640,
            sm: 640,
            md: 768,
            tablet: 768,
            desktop: 1024,
            lg: 1024,
            xl: 1280,
        }
        const innerWidth = window.innerWidth
        return innerWidth < breakpoints[device]
    },
    setPriceboxTerm(){
        if(!this.quote.package){
            return
        }
        if(!this.$refs.pricebox){
            return
        }
        if(this.quote.package.subscription_term === 'month'){
            this.$refs.pricebox.setYearly(false)
        }
        else{
            this.$refs.pricebox.setYearly(true)
        }
    },
    getLastTenDigits(phoneNumber) {
        return phoneNumber.slice(-10)
    },
    formatDate(dateString) {
        if (!dateString) return ''

        const date = this.$moment(dateString, 'YYYY-MM-DD', true)
        
        if (!date.isValid()) return ''

        return date.format('DD / MM / YYYY')
    }
}
